import { Phone } from "lucide-react";
import logo from "@/assets/oz-clean-logo.png";

const footerLinks = {
  Services: [
    { label: "Residential Cleaning", href: "#services" },
    { label: "End Of Lease Cleaning", href: "#services" },
    { label: "Office Cleaning", href: "#services" },
    { label: "Window Cleaning", href: "#services" },
    { label: "Carpet Cleaning", href: "#services" },
    { label: "Pressure Washing", href: "#services" },
    { label: "Builders Cleans", href: "#services" },
    { label: "Airbnb Cleaning", href: "#services" },
  ],
  Company: [
    { label: "About Us", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "Reviews", href: "#reviews" },
    { label: "Contact", href: "#quote" },
    { label: "Get A Quote", href: "#quote" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms & Conditions", href: "#" },
  ],
};

const Footer = () => (
  <footer className="bg-[#111111] pt-14 pb-8">
    <div className="container">
      <div className="mb-10">
        <img src={logo} alt="OZ CLEAN CO." className="h-24 md:h-28 w-auto mb-3" width="384" height="256" />
        <p className="text-[#FFD400] font-bold text-base">Professional Cleaning Done Right.</p>
        <p className="text-white/60 text-xs mt-1.5">Fully insured&nbsp;•&nbsp;Satisfaction guaranteed</p>

        <div className="mt-5">
          <p className="text-white/65 text-[11px] uppercase tracking-wider font-semibold mb-1.5">Call us</p>
          <a
            href="tel:1300000000"
            className="flex items-center gap-2 text-[#FFD400] font-bold text-xl hover:opacity-80 transition-opacity w-fit"
          >
            <Phone className="w-5 h-5" />
            1300 000 000
          </a>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8 mb-10">
        {Object.entries(footerLinks).map(([heading, links]) => (
          <div key={heading}>
            <p className="font-bold text-white text-sm mb-3.5">{heading}</p>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/45 text-sm hover:text-white/70 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10" />
      <div className="pt-5 text-white/60 text-xs text-center">
        © {new Date().getFullYear()} OZ CLEAN CO. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
